import { render, staticRenderFns } from "./MentorshipType.vue?vue&type=template&id=55b6d6be&scoped=true&"
import script from "./MentorshipType.vue?vue&type=script&lang=js&"
export * from "./MentorshipType.vue?vue&type=script&lang=js&"
import style0 from "./MentorshipType.vue?vue&type=style&index=0&id=55b6d6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6d6be",
  null
  
)

export default component.exports